import { KeyRound, ShieldCheck } from "lucide-react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { API } from "../data/siteData";

function formatError(detail) {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((item) => item?.msg || "Invalid input.").join(" ");
  return "Unable to sign in. Please check your details and try again.";
}

export default function AdminLoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [state, setState] = useState("idle");

  const signIn = async (event) => {
    event.preventDefault();
    setError("");
    setState("loading");
    try {
      const response = await fetch(`${API}/auth/admin-login`, {
        method: "POST",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const body = await response.json();
      if (!response.ok) throw new Error(formatError(body.detail));
      window.dispatchEvent(new Event("gameday-session-started"));
      navigate("/admin", { replace: true });
    } catch (signInError) {
      setError(signInError.message);
      setState("idle");
    }
  };

  return (
    <main className="portal-state" data-testid="admin-login-page">
      <span className="eyebrow">GAMEDAY Holdings LLC</span>
      <ShieldCheck size={34} />
      <h1 className="admin-login-heading" data-testid="admin-login-heading">ADMINISTRATOR SIGN-IN</h1>
      <p>Secure access for GAMEDAY Holdings Control Room administrators.</p>
      <form className="admin-login-form" onSubmit={signIn} data-testid="admin-login-form">
        <label>Email<input required type="email" autoComplete="email" value={email} onChange={(event) => setEmail(event.target.value)} data-testid="admin-login-email-input" /></label>
        <label>Password<input required type="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} data-testid="admin-login-password-input" /></label>
        {error && <p className="form-error" data-testid="admin-login-error">{error}</p>}
        <button className="button button--red" disabled={state === "loading"} data-testid="admin-login-submit-button"><KeyRound size={16} />{state === "loading" ? "Signing in…" : "Sign in to Control Room"}</button>
      </form>
      <Link className="text-button" to="/investor-portal" data-testid="admin-login-investor-portal-link">Investor portal</Link>
    </main>
  );
}